<span
  class="badge"
  *ngIf="text && text.length > 0"
  [class.badge--white-on-black]="theme === BadgeThemeEnum.WhiteOnBlack"
  [class.badge--black-on-white]="theme === BadgeThemeEnum.BlackOnWhite"
  [class.badge--extended]="text && text.length > 1"
>
  {{ text }}
</span>
